var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddcameraicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.03793 10.0367L7.53814 14.3745L4.37537 18.3499L0 10.7742L5.03793 10.0367ZM18.7516 17.4998V14.112C19.8517 13.6245 20.6268 12.5369 20.6268 11.2493C20.6268 10.5367 20.3767 9.87414 19.9642 9.3741L22.4269 7.93648C23.6895 7.19891 24.127 5.58628 23.3895 4.32367L21.6643 1.32341C21.3126 0.717122 20.7355 0.274421 20.0588 0.091776C19.382 -0.0908686 18.6606 0.00134785 18.0515 0.34833L7.88817 6.24883C6.70057 6.91139 6.28803 8.43652 6.97559 9.63662L8.85075 12.8869C9.53831 14.0745 11.0759 14.487 12.2635 13.7995L14.6137 12.4494C14.9263 13.1869 15.5138 13.787 16.2514 14.112V17.4998C16.2514 18.8749 17.3765 20 18.7516 20H25.0021V17.4998H18.7516Z",
    fill: "#ECECEC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddcameraicon);
export default __webpack_public_path__ + "static/media/addcameraicon.9e3be99998aad161949b3a7bd3886497.svg";
export { ForwardRef as ReactComponent };